import { EnvConstants } from "../EnvConstants";
import { RequestUtil } from "./RequestUtil";
import { DonwloadUtil } from "./DonwloadUtil";
import { SecurityUtil } from "./SecurityUtil";
import { NotificationUtil } from "./NotificationUtil";

export class S3Util {
  static async postWithAuthRetry(url, params) {
    let resp = await RequestUtil.postData(url, { params });

    if (resp?.status === 401) {
      console.log('Token expirado');

      const auth = sessionStorage.getItem('AUTH_USER');
      if (!auth) {
        SecurityUtil.setLogout();
        return '';
      }

      const user = JSON.parse(auth);

      await new Promise((resolve, reject) => {
        SecurityUtil.loginWithoutReload({
          username: user[0].username,
          fnOk: () => resolve(),
          fnError: () => reject()
        });
      });

      const retryResp = await RequestUtil.postData(url, { params });
      return retryResp || '';
    }

    return resp;
  }

  static getTemporalPutUrl(config) {
    const { folder, fileName, fnOk, fnError, contentType } = config;

    S3Util.postWithAuthRetry(
      EnvConstants.GET_FW_URL_UPLOAD_PRESIGNED_URL_PUT(),
      { folder, fileName, contentType }
    )
      .then(resp => {
        if (resp && fnOk) fnOk(resp);
      })
      .catch(error => {
        if (fnError) fnError(error);
      });
  }

  static getTemporalGetUrl(config) {
    const { folder, fileName, fnOk, fnError } = config;

    S3Util.postWithAuthRetry(
      EnvConstants.GET_FW_URL_UPLOAD_PRESIGNED_URL_GET(),
      { folder, fileName }
    )
      .then(resp => {
        if (resp && fnOk) fnOk(resp);
      })
      .catch(error => {
        if (fnError) fnError(error);
      });
  }

  static async getTemporalGetUrlAsync(fileName, folder) {
    const resp = await this.postWithAuthRetry(
      EnvConstants.GET_FW_URL_UPLOAD_PRESIGNED_URL_GET(),
      { folder, fileName }
    );

    return resp?.dataObject?.url || '';
  }


  static async getTemporalDeleteUrlAsync(fileName, folder) {
    const resp = await S3Util.postWithAuthRetry(
      EnvConstants.GET_FW_URL_UPLOAD_PRESIGNED_URL_DELETE(),
      { folder, fileName }
    );

    return resp.dataObject.url || '';
  }


  static async donwload(fileName, folder) {
    let url = await S3Util.getTemporalGetUrlAsync(fileName, folder);
    console.log('fileName.getTemporalGetUrlAsync', url);
    console.log('fileName', fileName);
    console.log('folder', folder)
    DonwloadUtil.donwloadGet(url, fileName);
  }

  static async preview(fileName, folder) {
    let url = await S3Util.getTemporalGetUrlAsync(fileName, folder);
    return await DonwloadUtil.getBase64(url, fileName);
  }

  static async getUrlS3(fileName, folder) {
    let url = await S3Util.getTemporalGetUrlAsync(fileName, folder);
    return url;
  }

  static async delete(fileName, folder) {
    let url = await S3Util.getTemporalDeleteUrlAsync(fileName, folder);
    console.log('fileName.getTemporalDeleteUrlAsync', url);
    fetch(url, {
      method: 'DELETE',
    })
      .then(res => res.json()) // or res.json()
      .then(res => console.log(res));
  }



  /*
  static downloadS3 = async(fileName, folder) => {
      S3Util.getTemporalGetUrl({
          folder: folder,
          fileName: fileName,
          fnOk: (resp) => {
              console.log(resp);
              if (resp?.dataObject?.url)
                  DonwloadUtil.donwloadGet(resp.dataObject.url, fileName);
          },
          error: (error) => {
              console.error(error);
          }
      });
  }*/

}

